import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <AboutSection />
        <AppSection />
        <ContactSection />
        <TopicsSection />
        <FAQSection />
        <CardsSection />
        <CommentsSection />
        <IndexSection />
        <CarouselSection />
        <FeaturesSection />
        <MediaSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}